import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./Button.js";
export function Skeleton({ linhas = 3, altura = 16, largura = "100%", }) {
    return (_jsx("div", { "aria-hidden": "true", "data-skeleton": "", style: { display: "grid", gap: 10, width: largura }, children: Array.from({ length: linhas }, (_, i) => (_jsx("div", { style: {
                height: altura,
                borderRadius: 8,
                background: "var(--border)",
                opacity: 0.7,
                width: i === linhas - 1 && linhas > 1 ? "60%" : "100%",
            } }, i))) }));
}
export function EstadoVazio({ titulo, orientacao, acao, }) {
    return (_jsxs("div", { role: "status", style: {
            padding: 28,
            textAlign: "center",
            border: "1px dashed var(--border)",
            borderRadius: 12,
            color: "var(--text-muted)",
            display: "grid",
            gap: 8,
            justifyItems: "center",
        }, children: [_jsx("strong", { style: { color: "var(--text)", fontSize: 14 }, children: titulo }), orientacao ? _jsx("span", { style: { fontSize: 13, maxWidth: 520 }, children: orientacao }) : null, acao ? (_jsx(Button, { size: "sm", variant: "ghost", onClick: acao.onClick, children: acao.rotulo })) : null] }));
}
export function EstadoErro({ mensagem, onTentarDeNovo }) {
    return (_jsxs("div", { role: "alert", style: {
            padding: 20,
            border: "1px solid var(--danger-500)",
            borderRadius: 12,
            color: "var(--danger-500)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            flexWrap: "wrap",
        }, children: [_jsx("span", { style: { fontSize: 13 }, children: mensagem }), onTentarDeNovo ? (_jsx(Button, { size: "sm", variant: "ghost", onClick: onTentarDeNovo, children: "Tentar de novo" })) : null] }));
}
//# sourceMappingURL=Estados.js.map